<forge-text-field [invalid]="isInvalid" data-lpignore="true" [attr.shape]="forCellEdit ? 'squared' : null"
  [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="Density"
  [required]="isRequired" [attr.label-position]="LabelPosition">
  <input #input type="text" [disabled]="isViewOnly" [name]="name" id="txt_{{name}}" [(ngModel)]="valueModel"
    (input)="onInputChange()" (change)="onChange()" [required]="isRequired" class="number-field" focusOnLoad [propertyMetadata]="propertyMetadata"
    [forCellEdit]="forCellEdit" data-lpignore="true" (paste)="handlePaste($event)" (blur)="onBlur($event)"
    autocomplete="off" attr.telemetry="Edit-{{label}}" tabindex="0"
    (keydown)="enforceFormat($event)" (keyup)="checkFormat($event)">
    <label for="txt_{{name}}">{{label}}</label>
    @if (hint && !isInvalid && !dense && !compact) {
      <span slot="support-text">{{hint}}</span>
    }
    @if (isInvalid && !dense && !compact) {
      <span slot="support-text" class="error-red">{{error}}</span>
    }
    @if (showSpinner) {
      <forge-circular-progress class="metadata-input--spinner" slot="end">
      </forge-circular-progress>
    }
  </forge-text-field>
